pluginValidators = require 'lib/plugins/plugin-validators'
PluginBadgeView = require 'views/plugin/plugin-badge-view'
t = require('teacup')
trackUe = require 'debug/trackUe'
Util = require 'lib/util'

template = t.renderable ({ callback, url, title, text } = {}) ->
  t.h3 '.card-detail-item-header', ->
    t.text title

  if url && pluginValidators.isValidUrlForIframe(url)
    t.a '.card-detail-badge.plugin-card-detail-badge.is-clickable.js-badge',
      { href: url, rel: 'noreferrer nofollow noopener', target: url, title: text }, ->
        t.text text
  else if callback
    t.a '.card-detail-badge.plugin-card-detail-badge.is-clickable.js-badge',
      { href: '#', title: text }, ->
        t.text text
  else
    t.span '.card-detail-badge.plugin-card-detail-badge.js-badge',
      { title: text }, ->
        t.text text

module.exports = class PluginCardDetailBadgeView extends PluginBadgeView
  tagName: 'div'
  className: 'card-detail-item'

  renderBadge: (badge) ->
    @$el.html(template(badge))
    @$('.js-badge')

  events:
    'click .js-badge': (e) ->
      Util.stopPropagation(e)
      trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-detail-badge', @pluginBadge.idPlugin)
      if @pluginBadge.callback?
        e.preventDefault()
        @pluginBadge.callback
          el: e.currentTarget
        .done()



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-card-detail-badge-view.coffee